// 从 user-poster-editor/src/collapse/views/materialCollapse/components/search/filtrateContent.tsx 搬迁
import classNames from 'classnames';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { IColorItem } from '@/types';

interface IMaterialContentFilterProps {
    color: IColorItem | null;
    setColor: Function;
    handleClick: Function;
    colorsList: IColorItem[];
}
const MaterialContentFilter: React.FC<IMaterialContentFilterProps> = ({
    color,
    setColor,
    handleClick,
    /**
     * @FIXME 旧代码, 需要改成从上层业务获取数据后传入
     * import { categoryTagList } from '@/services/material';
     *  const {
     *      data: { data }
     *  } = await categoryTagList({
     *      type: 'pic_static_sticker',
     *      code: 'colors'
     *  });
     *  setColorsList(data?.tags?.filter((v) => v.color) || []);
     */
    colorsList,
}) => {
    const handleSelectColor = (item: IColorItem) => {
        const isSetColor = item.id !== color?.id;
        isSetColor ? setColor(item) : setColor(null);
        handleClick?.(isSetColor);
    };

    return (
        <div className="filtrate-container">
            <div className="filtrate-list">
                {colorsList.map((item, index) => {
                    return (
                        <div
                            className={classNames('colorItem', {
                                active: item.id === color?.id,
                            })}
                            key={index}
                            onClick={() => handleSelectColor(item)}
                            style={{ background: item.color }}
                        >
                            <IconFont name="CheckBlack" fontSize={14}></IconFont>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default React.memo(MaterialContentFilter);
